// =====================================================================
// heroScrollMotion — framework-free config for the hero section's
// scroll-linked fade/shrink (LandingPage.jsx: `useScroll` + two
// `useTransform` calls feeding `style={{ opacity, scale }}` on the hero
// `<motion.section>`).
//
// Extracted so the reduced-motion decision is a plain, testable function
// instead of only living inline where it's easy to forget to gate — which
// is exactly what had happened: the opacity/scale transforms ran
// unconditionally, so a prefers-reduced-motion visitor still got the
// hero shrinking/fading as they scrolled, contrary to this project's
// reduced-motion contract (TypewriterEffectSmooth already honours it).
// =====================================================================

// scrollYProgress input range the hero's opacity/scale ease across —
// the first 20% of total page scroll. Unaffected by reduced motion
// (it's just where in the scroll the transform range applies).
export const HERO_SCROLL_INPUT_RANGE = [0, 0.2]

// Output ranges for `useTransform(scrollYProgress, HERO_SCROLL_INPUT_RANGE, output)`.
// Reduced motion collapses both to a constant 1 — same values in and
// out — so `useTransform` still returns a valid (inert) MotionValue
// instead of the caller having to conditionally skip the hook.
export function getHeroScrollRanges(prefersReducedMotion) {
  if (prefersReducedMotion) {
    return { opacityOutput: [1, 1], scaleOutput: [1, 1] }
  }
  return { opacityOutput: [1, 0], scaleOutput: [1, 0.8] }
}
